import React from "react";
import { Dialog, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import "./customModal.css";

const ImageModal = ({ open, onClose, imgSrc }) => {
    return (
        <Dialog 
            open={open}
            onClose={onClose}
            maxWidth="md"
            PaperProps={{
                style: {
                    borderRadius: "8px",
                    backgroundColor: "rgba(0, 0, 0, 0.8)",
                    overflow: "hidden",
                    position: "relative",
                },
            }}
            className="custom-dialog-container"
        >
            <IconButton
                onClick={onClose}
                aria-label="close"
                style={{
                    position: "absolute",
                    top: "8px",
                    right: "8px",
                    zIndex: 1,
                    color: "#fff",
                    transition: "background-color 0.3s ease",
                    "&:hover": {
                        backgroundColor: "rgba(0, 0, 0, 0.3)",
                    },
                }}
            >
                <CloseIcon
                    style={{
                        transition: "color 0.3s ease",
                        color: "rgba(0, 0, 0, 0.3)",
                        "&:hover": {
                            color: "#fff",
                        },
                    }}
                />
            </IconButton>

            <img
                src={imgSrc}
                alt="Producto"
                style={{
                    display: "block",
                    maxWidth: "100%",
                    maxHeight: "80vh",
                    width: "auto",
                    height: "auto",
                }}
            />
        </Dialog>
    );
};

export default ImageModal;
